var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { capitalizeFirst } from '@/lib/misc/utils';
export class RemoteAllowNonCloudTrafficHandler {
    constructor() {
        this.allownoncloudtraffic = ['Enabled', 'Disabled'];
        this.getFormattedSuperSelectOptions = (entities) => {
            return this.allownoncloudtraffic.map((auth) => {
                return {
                    value: auth,
                    inputDisplay: capitalizeFirst(auth)
                };
            });
        };
    }
    listEntity() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                resolve(this.allownoncloudtraffic);
            });
        });
    }
}
